import { ActionButton, Body, ListItem, MainButton, TextArea, Title } from '@icarros/ids-react';
import {
  ActionButtonCustom,
  ActionsButtonsWrapper,
  ModalContainer,
  OpenEditTitleWrapper,
  OpenEditWrapper,
  SuccessChassiModalLayout,
  SuccessChassiModalLayoutLogoFeedback,
  SuccessChassiModalLayoutMainContent
} from './style';
import React, { Dispatch, SetStateAction, useState } from 'react';

import { ModalInfoChassi } from './ModalInfoChassi';
import { ReactComponent as VerificarChassi } from '../../../../assets/rebranding/feedback/alerts/chassi-verificado.svg';
import toastify from '../../../lib/toastify';
import { useAd } from '../../../store/hooks/useAd';
import { useAdContext } from '../../../store/contexts/ad';
import { useMutation } from '@tanstack/react-query';
import { verificationChassi } from '../../../services/Edits.service';

interface ChassiFormProps {
  onClose: () => void;
  modalInfoChassi: boolean;
  setModalInfoChassi: Dispatch<SetStateAction<boolean>>;
}

export function ChassiForm({
  onClose,
  modalInfoChassi,
  setModalInfoChassi
}: ChassiFormProps): JSX.Element {
  const { currentAd } = useAdContext();
  const { setCurrentContent } = useAd();
  const { id, veiculo } = currentAd;
  const [chassi, setChassi] = useState('');
  const [modalChassiVerified, setModalChassiVerified] = useState<'FORM' | 'SUCCESS'>('FORM');
  const veihiclePlate = veiculo.placa;

  const { mutate: verifyChassiMutation, isLoading } = useMutation({
    mutationFn: () => verificationChassi({ idAnuncio: id, chassi, veihiclePlate }),
    onSuccess: () => {
      setCurrentContent({
        chassiVerificado: {
          mensagem: chassi,
          status: true
        }
      });

      setModalChassiVerified('SUCCESS');
    },
    onError: () => {
      toastify.error(
        'Chassi inválido',
        'O chassi não corresponde com a placa do veículo. Tente de novo.'
      );
    }
  });

  return (
    <OpenEditWrapper>
      {modalChassiVerified === 'FORM' ? (
        <>
          <OpenEditTitleWrapper>
            <Title size="base">Adicione o número do chassi</Title>
          </OpenEditTitleWrapper>

          <Body>
            O chassi, combinado com a placa, confirma a existência do seu veículo. Vamos exibir no
            seu anúncio a mensagem de ”placa e chassi verificados”, o que aumenta a confiabilidade
            do seu anúncio e também as chances dele ser visto por possíveis compradores.
          </Body>

          <ModalContainer>
            <ActionButtonCustom>
              <ActionButton
                iconName="itaufonts_informacao"
                text="Onde encontrar essa informação?"
                variant="secondary"
                weight="medium"
                onClick={() => {
                  setModalInfoChassi(true);
                }}
              />
            </ActionButtonCustom>

            <ListItem
              avatarVariant="icon"
              avatarIcon="itaufonts_seguranca"
              avatarIconProperties={{ variant: 'secondary' }}
              AvatarSize="medium"
              label="O chassi não será exibido no anúncio"
              hasLine={false}
            />

            <TextArea
              label="Indique os 8 últimos dígitos do chassi"
              onChange={e => setChassi(e.target.value)}
              value={chassi}
              maxChar={8}
              limitCounter={false}
              isError={status === 'error'}
              helperText={status === 'error' ? 'Não conseguimos encontrar o chassi' : ''}
            />
          </ModalContainer>

          <ActionsButtonsWrapper>
            <MainButton
              onClick={() => onClose()}
              fillContainer
              variant="secondary"
              text="Cancelar"
            />
            <MainButton
              isLoading={isLoading}
              onClick={() => verifyChassiMutation()}
              fillContainer
              text={'Verificar chassi'}
            />
          </ActionsButtonsWrapper>
        </>
      ) : (
        <SuccessChassiModalLayout>
          <SuccessChassiModalLayoutLogoFeedback>
            <VerificarChassi />
          </SuccessChassiModalLayoutLogoFeedback>
          <SuccessChassiModalLayoutMainContent>
            <Title>Chassi verificado</Title>
            <Body>
              No seu anúncio vamos exibir a mensagem ”placa e chassi verificados”. Essa informação
              gera mais confiança para quem deseja comprar o seu carro.
            </Body>
          </SuccessChassiModalLayoutMainContent>
          <MainButton onClick={() => onClose()} fillContainer text="Retornar para edição" />
        </SuccessChassiModalLayout>
      )}

      <ModalInfoChassi modalOpen={modalInfoChassi} setModalOpen={setModalInfoChassi} />
    </OpenEditWrapper>
  );
}
